export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7723.8583f185.jpg";